/**
 * ProofWall: why-us accordion (single-open). Clicking an item opens it and
 * closes any sibling that was open.
 */
(function ($) {
    'use strict';

    $(function () {
        $('.mnhq-proof__accordion').on('click', '.mnhq-accordion__trigger', function () {
            var $trigger = $(this);
            var $item    = $trigger.closest('.mnhq-accordion__item');
            var willOpen = !$item.hasClass('is-open');

            // Close every sibling first.
            $item.siblings('.mnhq-accordion__item').removeClass('is-open')
                .find('.mnhq-accordion__trigger').attr('aria-expanded', 'false');

            $item.toggleClass('is-open', willOpen);
            $trigger.attr('aria-expanded', String(willOpen));
        });
    });
})(jQuery);
